import React, { type InputHTMLAttributes, useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { length as Length } from "src/shared/forms/validations/Length";
import { required as Required } from "src/shared/forms/validations/Required";
import TextValidation from "src/shared/forms/validations/TextValidation";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface ICityInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {
  isRequired?: boolean;
}

export default ({
  inputID,
  label = <FormattedMessage id="contacts.city" />,
  validationDisabled = false,
  isRequired = true,
  ...rest
}: ICityInputProps) => {
  const validations: ValidationHandler[] = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }

    const validations = [
      Length(2, 64),
      TextValidation(<FormattedMessage id="form.validations.city.invalid" />),
    ];
    if (isRequired) {
      validations.push(Required);
    }
    return validations;
  }, [isRequired, validationDisabled]);

  return (
    <Field
      name={inputID}
      label={label}
      type="text"
      component={InputRenderer}
      validate={validations}
      {...rest}
    />
  );
};
